import { useEffect } from 'react';

export const SEOHead = ({ settings }) => {
  useEffect(() => {
    if (!settings) return;

    // Update document title
    const title = settings.seo_title || settings.site_name || 'DJ Services';
    document.title = title;

    // Helper to update or create meta tag
    const setMeta = (name, content, property = false) => {
      if (!content) return;
      const attr = property ? 'property' : 'name';
      let tag = document.querySelector(`meta[${attr}="${name}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attr, name);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };

    // Basic SEO meta tags
    setMeta('description', settings.seo_description);
    setMeta('keywords', settings.seo_keywords);

    // Robots meta tag
    const robotsContent = [
      settings.robots_index !== false ? 'index' : 'noindex',
      settings.robots_follow !== false ? 'follow' : 'nofollow'
    ].join(', ');
    setMeta('robots', robotsContent);

    // Open Graph tags
    setMeta('og:title', settings.seo_title || settings.site_name, true);
    setMeta('og:description', settings.seo_description, true);
    setMeta('og:type', 'website', true);
    setMeta('og:site_name', settings.site_name, true);
    if (settings.og_image_data) {
      setMeta('og:image', settings.og_image_data, true);
    }

    // Twitter Card tags
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', settings.seo_title || settings.site_name);
    setMeta('twitter:description', settings.seo_description);
    if (settings.og_image_data) {
      setMeta('twitter:image', settings.og_image_data);
    }

    // Update favicon
    if (settings.favicon_data) {
      let favicon = document.querySelector('link[rel="icon"]');
      if (!favicon) {
        favicon = document.createElement('link');
        favicon.rel = 'icon';
        document.head.appendChild(favicon);
      }
      favicon.href = settings.favicon_data;

      // Also set apple-touch-icon
      let appleFavicon = document.querySelector('link[rel="apple-touch-icon"]');
      if (!appleFavicon) {
        appleFavicon = document.createElement('link');
        appleFavicon.rel = 'apple-touch-icon';
        document.head.appendChild(appleFavicon);
      }
      appleFavicon.href = settings.favicon_data;
    }

    // Google Analytics
    if (settings.google_analytics_id && !window.gaInitialized) {
      // Load GA script
      const gaScript = document.createElement('script');
      gaScript.async = true;
      gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${settings.google_analytics_id}`;
      document.head.appendChild(gaScript);

      // Initialize GA
      window.dataLayer = window.dataLayer || [];
      function gtag() { window.dataLayer.push(arguments); }
      window.gtag = gtag;
      gtag('js', new Date());
      gtag('config', settings.google_analytics_id);
      window.gaInitialized = true;
    }

  }, [settings]);

  return null; // This component doesn't render anything
};

export default SEOHead;
